<template>
    <CustomHeader name="Trang chủ"/>

    <div class="justify-content-center d-flex mt-5">
        <Hero/>
    </div>
    
    <div class="justify-content-center d-flex mt-5">
        <Recomment/>
    </div>

    <div class="justify-content-center d-flex mt-5">
        <Reason/>
    </div>

    <div class="justify-content-center d-flex mt-5">
        <Guarantee/>
    </div>
    
    <Footer/>
</template>
<script>
import CustomHeader from "./components/CustomHeader.vue";
import Hero from "./components/Hero.vue";
import Recomment from './components/Recomment.vue'
import Reason from './components/Reason.vue'
import Guarantee from './components/Guarantee.vue'
import Footer from './components/Footer.vue'

export default{
    components:{
        CustomHeader,
        Hero,
        Recomment,
        Reason,
        Footer,
        Guarantee
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}   
</script>